import { alpha, Box, Button, Container, Typography } from "@mui/material";
import { motion, Variants } from "framer-motion";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

function CommonWhatsAppCTA() {


    const fadeUp: Variants = {
        hidden: { opacity: 0, y: 40 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.65, ease: [0.25, 0.46, 0.45, 0.94] } },
    };
    const PRIMARY = '#2E673E';
    const WHATSAPP_URL = 'https://wa.me/972542421677?text=%D7%A9%D7%9C%D7%95%D7%9D%2C%20%D7%90%D7%A0%D7%99%20%D7%9E%D7%A2%D7%95%D7%A0%D7%99%D7%99%D7%9F%20%D7%9C%D7%A7%D7%91%D7%9C%20%D7%94%D7%A6%D7%A2%D7%AA%20%D7%9E%D7%97%D7%99%D7%A8';

    return (
        <Box
            component={motion.section as any}
            initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.5 }}
            variants={fadeUp}
            sx={{
                background: `linear-gradient(120deg, #1a3d24 0%, ${PRIMARY} 55%, #2e5e1e 100%)`,
                py: { xs: 7, md: 10 },
                position: 'relative',
                overflow: 'hidden',
            }}
        >
            {/* decorative blobs */}
            <Box sx={{ position: 'absolute', top: -60, left: -60, width: 260, height: 260, borderRadius: '50%', background: 'rgba(255,255,255,0.04)', pointerEvents: 'none' }} />
            <Box sx={{ position: 'absolute', bottom: -80, right: -40, width: 320, height: 320, borderRadius: '50%', background: 'rgba(255,255,255,0.03)', pointerEvents: 'none' }} />

            <Container maxWidth="md" sx={{ position: 'relative', textAlign: 'center' }}>
                <Typography variant="overline" sx={{ color: alpha('#fff', 0.65), fontWeight: 700, letterSpacing: 3, display: 'block', mb: 1 }}>
                    מוכנים להתחיל?
                </Typography>
                <Typography variant="h3" sx={{ color: '#fff', fontWeight: 800, mb: 2, lineHeight: 1.25 }}>
                    שלחו לנו הודעה בוואטסאפ
                </Typography>
                <Typography variant="h6" sx={{ color: alpha('#fff', 0.78), fontWeight: 400, mb: 5, maxWidth: 500, mx: 'auto' }}>
                    קבל הצעת מחיר אישית תוך שעות — ללא התחייבות
                </Typography>
                <Button
                    component="a"
                    href={WHATSAPP_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    variant="contained"
                    size="large"
                    startIcon={<WhatsAppIcon />}
                    sx={{
                        bgcolor: '#25D366',
                        color: '#fff',
                        fontWeight: 700,
                        fontSize: '1.1rem',
                        px: 5,
                        py: 1.8,
                        borderRadius: 3,
                        boxShadow: '0 8px 32px rgba(37,211,102,0.4)',
                        '&:hover': {
                            bgcolor: '#1ebe5d',
                            boxShadow: '0 12px 40px rgba(37,211,102,0.55)',
                            transform: 'translateY(-2px)',
                        },
                        transition: 'all 0.25s ease',
                    }}
                >
                    שלח הודעה עכשיו
                </Button>
                <Typography variant="body2" sx={{ color: alpha('#fff', 0.5), mt: 2.5 }}>
                    054-242-1677 ·  שעות פעילות: ש׳–ה׳ 07:00–17:30
                </Typography>
            </Container>
        </Box>
    );
}

export default CommonWhatsAppCTA;